/*
 *
 * Date: 2025
 * Description: Alert component
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { Box , Alert } from "@mui/material";

//Interfaces
import { i_alert_control } from "../../interfaces/utility.interface";

const AlertTop = ( props : i_alert_control  ) => {

    return (
        <Box sx={[ props.float === 'top' && { position : 'absolute' , top : props.top, left: '50%', zIndex : '1000000000' , transform: 'translate(-50%, -50%)',}]}>
            { props.alert.open &&
                <Alert sx={{ marginTop : '1vh' , marginBottom : '1vh'}} severity={props.alert.severity} onClose={props.onClose}>
                    {props.alert.message}
                </Alert>
            }
        </Box>
    )
}

export default AlertTop;